<template>
  <el-dialog
    title="物流轨迹"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="p20">
        <p class="f24 mb20">{{ express.express_name }} {{ express.express_no }}</p>
        <el-timeline v-if="express.delivery_platform==0">
            <el-timeline-item
            v-for="(item, index) in express.list"
            :key="index"
            :color="index==0 ? '#1989fa' : ''"
            :timestamp="item.time">
            <el-tag :type="item.status=='在途' ? 'info' : ''">{{item.status}}</el-tag>
            {{item.context}}
            </el-timeline-item>
        </el-timeline>
        <el-timeline v-if="express.delivery_platform==10">
            <el-timeline-item
            v-for="(item, index) in express.list"
            :key="index"
            :color="index==0 ? '#1989fa' : ''"
            :timestamp="item.AcceptTime">
            {{item.AcceptStation}}
            </el-timeline-item>
        </el-timeline>
    </div>
  </el-dialog>
</template>

<script>
import CustomizationApi from '@/api/customization.js';
export default {
  data() {
    return {
      order_id: 0,
      loading: false,
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: true,
      express: {
          express_name: '',
          express_no: '',
      }
    };
  },
  props: ["dataModel"],
  created() {
    this.order_id = this.dataModel.order_id;
    this.getData();
  },
  methods: {
    /*获取参数*/
    getData() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.dataModel.order_id;
      CustomizationApi.getExpressTrack(
        {
          order_id: params,
        },
        true
      )
        .then((data) => {
          self.loading = false;
          self.express = data.data.express;
          console.log(self.express);
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog", { openDialog: false });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/customization/order/dialog/Track.vue